import { useEffect, useState } from "react";
import axios from "axios";
import { getRoleId } from "Common/Components/getRoleId";
import { isAdminRole } from "Common/constants/roles";

const BASE_URL = "https://portal-api.mahanpanel.com";

const getToken = () =>
  localStorage.getItem("app_at_mahan") || sessionStorage.getItem("app_at_mahan");

/**
 * نقش کاربر جاری.
 *
 * مقدار اولیه از payload توکن خوانده می‌شود تا رابط کاربری در همان رندر اول درست
 * ساخته شود (بدون یک لحظه نمایش دکمه‌هایی که کاربر اجازه‌شان را ندارد)، و بلافاصله
 * با پاسخ GET /auth/me که مرجع است اصلاح می‌شود.
 */
const useCurrentRole = () => {
  const [roleId, setRoleId] = useState<number | null>(() => {
    const fromToken = getRoleId(getToken());
    return typeof fromToken === "number" ? fromToken : null;
  });
  const [userId, setUserId] = useState<number | null>(null);
  const [salesEnabled, setSalesEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    const fetchMe = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (cancelled) return;
        if (typeof res.data?.role_id === "number") setRoleId(res.data.role_id);
        if (typeof res.data?.id === "number") setUserId(res.data.id);
        if (typeof res.data?.sales_enabled === "boolean") setSalesEnabled(res.data.sales_enabled);
      } catch (error) {
        console.error("Error fetching current user role:", error);
      }
    };
    fetchMe();
    return () => {
      cancelled = true;
    };
  }, []);

  return { roleId, userId, salesEnabled, isAdmin: isAdminRole(roleId) };
};

export default useCurrentRole;
